<template>
  <div class="bg-gradient"></div>
  <div class="bg-texture"></div>
  <main class="container">
    <img
      ref="logo"
      src="@/assets/logo.png"
      alt="취준생 키우기 로고"
      class="logo"
      fetchpriority="high"
      decoding="async"
      @load="onLogoLoad"
    />
    <h1 class="title">사전예약 진행 중</h1>
    <p class="subtitle">
      지금 사전예약하고 출시 알림과 리워드 보상을 받아보세요.
    </p>

    <div class="store-buttons">
      <a :href="googlePlayUrl" class="store-badge" aria-label="Google Play에서 사전예약">
        <img src="@/assets/google_play_prereg_ko.png" alt="Google Play에서 사전예약"/>
      </a>
      <a :href="appStoreUrl" class="store-badge" aria-label="App Store에서 사전주문">
        <img src="@/assets/app_store_preorder_ko.svg" alt="App Store에서 사전주문"/>
      </a>
    </div>

    <div class="qr-section">
      <div class="qr-card">
        <img src="@/assets/preorder_qr.png" alt="사전예약 QR 코드" class="qr-code" decoding="async"/>
      </div>
      <p class="qr-caption">휴대폰으로 QR 코드를 스캔해 사전예약하세요</p>
    </div>

    <footer class="footer">
      <p>
        회사명 : 바삭한소프트 | 주소 : 서울시 성동구 왕십리로 222, 한양대학교 코맥스스타트업타운 1층 유니콘룸 | 사업자등록번호 : 306-09-10281 <br/>
        통신판매업신고번호: 제 2024-서울성동-0973 호 | 문의 : contact@basakansoft.com
      </p>
    </footer>
  </main>
</template>

<script>
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.basakansoft.jobmaker';
const APP_STORE_URL = 'https://apps.apple.com/kr/app/id6747634441';

export default {
  name: 'PreRegistration',
  data() {
    return {
      googlePlayUrl: GOOGLE_PLAY_URL,
      appStoreUrl: APP_STORE_URL,
      pendingRedirectUrl: null,
      redirected: false,
      safetyTimer: null,
    };
  },
  mounted() {
    const ua = navigator.userAgent || '';
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    // iPadOS 13+ reports as Macintosh; disambiguate via touch points.
    const isIPadOS = /Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1;

    if (isAndroid) {
      this.pendingRedirectUrl = GOOGLE_PLAY_URL;
    } else if (isIOS || isIPadOS) {
      this.pendingRedirectUrl = APP_STORE_URL;
    } else {
      return;
    }

    // Wait for the logo to load before navigating away. iOS Safari cancels
    // in-flight image requests on navigation, leaving a broken <img> in the
    // bfcache snapshot when the user comes back. Loading first avoids that.
    const logo = this.$refs.logo;
    if (logo && logo.complete && logo.naturalWidth > 0) {
      this.doRedirect();
    } else {
      // Safety net: don't trap users if the asset is unusually slow.
      this.safetyTimer = setTimeout(() => this.doRedirect(), 1500);
    }
  },
  beforeUnmount() {
    if (this.safetyTimer) clearTimeout(this.safetyTimer);
  },
  methods: {
    onLogoLoad() {
      if (this.pendingRedirectUrl) this.doRedirect();
    },
    doRedirect() {
      if (this.redirected || !this.pendingRedirectUrl) return;
      this.redirected = true;
      if (this.safetyTimer) clearTimeout(this.safetyTimer);
      window.location.replace(this.pendingRedirectUrl);
    },
  },
};
</script>

<style scoped>
.bg-gradient {
  position: fixed;
  inset: 0;
  background: linear-gradient(180deg, #73C4FC 0%, #3AA0E7 100%);
  z-index: -2;
}

.bg-texture {
  position: fixed;
  inset: 0;
  background-image: url('@/assets/bg_texture2.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
  pointer-events: none;
}

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 40px 20px 110px;
  text-align: center;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.logo {
  width: 240px;
  margin-bottom: 28px;
  filter: drop-shadow(0 8px 22px rgba(15, 60, 110, 0.35));
}

.title {
  margin: 0 0 14px;
  font-size: 34px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #ffffff;
  -webkit-text-stroke: 5px #0F4D88;
  paint-order: stroke fill;
  text-shadow: 0 6px 12px rgba(15, 60, 110, 0.35);
}

.subtitle {
  margin: 0 0 36px;
  font-size: 16px;
  line-height: 1.65;
  color: #ffffff;
  text-shadow: 0 2px 6px rgba(15, 60, 110, 0.35);
}

.store-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
}

.store-badge {
  display: inline-block;
  text-decoration: none;
  transition: transform 0.15s ease, filter 0.15s ease;
  filter: drop-shadow(0 8px 18px rgba(15, 60, 110, 0.35));
}

.store-badge:hover {
  transform: translateY(-2px);
  filter: drop-shadow(0 12px 22px rgba(15, 60, 110, 0.45));
}

.store-badge img {
  display: block;
  height: 56px;
  width: auto;
}

.qr-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.qr-card {
  background: #ffffff;
  padding: 14px;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 60, 110, 0.35);
}

.qr-code {
  display: block;
  width: 180px;
  height: 180px;
  image-rendering: pixelated;
}

.qr-caption {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 0 2px 6px rgba(15, 60, 110, 0.35);
}

/* Phones auto-redirect to the store, so the QR is only useful on desktop. */
@media (hover: none) and (pointer: coarse) {
  .qr-section { display: none; }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px max(12px, env(safe-area-inset-left)) calc(12px + env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-right));
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 11.5px;
  text-shadow: 0 1px 2px rgba(15, 60, 110, 0.35);
  pointer-events: none;
}

.footer p {
  margin: 0;
  pointer-events: auto;
}

@media (max-width: 600px) {
  .logo { width: 180px; }
  .title { font-size: 26px; }
  .subtitle { font-size: 15px; }
  .store-badge img { height: 48px; }
}
</style>
